__turbopack_context__.v({
  "balanceSc": "styles-module-scss-module__sgh5Ia__balanceSc",
  "title": "styles-module-scss-module__sgh5Ia__title",
});
